import { defineMessages } from 'react-intl';

export default defineMessages({
  printerTitle: {
    id: 'components.printDialog.selectPrinter.title',
    defaultMessage: 'Select a printer',
    description: 'select printer title of the printer dialog',
  },
  positionsTitle: {
    id: 'components.printDialog.selectPositions.title',
    defaultMessage: 'Exclude printing positions',
    description: 'select printing positions title of the printer dialog',
  },
  failedJobsTitle: {
    id: 'components.printDialog.failedJobs.title',
    defaultMessage: 'Failed printing jobs',
    description: 'failed jobs title of the printer dialog',
  },
  positionsDescription: {
    id: 'components.printDialog.excludePrintingPositions.description',
    defaultMessage:
      'Exclude print positions and indicate which areas of the sheet are already used, so no {category} are printed there. Or continue printing.',
    description: 'Exclude printing positions description of the printer dialog',
  },
  back: {
    id: 'actions.back',
    defaultMessage: 'Back',
    description: 'label of the back action',
  },
  changePrinter: {
    id: 'common.changePrinter',
    defaultMessage: 'Change printer',
    description: 'Common label for change printer',
  },
  close: {
    id: 'actions.close',
    defaultMessage: 'Close',
    description: 'label of the close action',
  },
  cancel: {
    id: 'actions.cancel',
    defaultMessage: 'Cancel',
    description: 'label of the cancel action',
  },
  confirm: {
    id: 'actions.confirm',
    defaultMessage: 'Confirm',
    description: 'label of the confirm action',
  },
  documents: {
    id: 'common.documents',
    defaultMessage: 'Documents',
    description: 'Common label for documents',
  },
  edit: {
    id: 'actions.edit',
    defaultMessage: 'Edit',
    description: 'label of the edit action',
  },
  loadingPrinters: {
    id: 'feedback.loadingPrinters.message',
    defaultMessage: 'Loading printers',
    description: 'Feedback message for loading printers',
  },
  saveAndPrint: {
    id: 'actions.saveAndPrint',
    defaultMessage: 'Save & print',
    description: 'label of the save and print action',
  },
  print: {
    id: 'actions.print',
    defaultMessage: 'Print',
    description: 'label of the print action',
  },
  printer: {
    id: 'common.printer',
    defaultMessage: 'Printer',
    description: 'Common label for printer',
  },
  printWithSystemDialog: {
    id: 'actions.printWithSystemDialog',
    defaultMessage: 'Print with system dialog',
    description: 'label of the print action',
  },
  retryAll: {
    id: 'actions.retryAll',
    defaultMessage: 'Retry all',
    description: 'label of the retry all action',
  },
  retryDifferentPrinter: {
    id: 'actions.retryDifferentPrinter',
    defaultMessage: 'Retry: different printer',
    description: 'label of the retry different printer action',
  },
  tryAgain: {
    id: 'actions.tryAgain',
    defaultMessage: 'Try again',
    description: 'label of the try again action',
  },
  paperType: {
    id: 'components.printDialog.printerTypes.paper',
    defaultMessage: 'A4 printers',
    description: 'label of the paper printer type',
  },
  labelType: {
    id: 'components.printDialog.printerTypes.label',
    defaultMessage: 'Label printers',
    description: 'label of the label printer type',
  },
  noLabelPrinters: {
    id: 'components.printDialog.selectPrinter.noLabelPrinters',
    defaultMessage: 'No label printers found',
    description: 'empty label printers list message of the printer dialog',
  },
  noA4Printers: {
    id: 'components.printDialog.selectPrinter.noA4Printers',
    defaultMessage: 'No A4 printers found',
    description: 'empty A4 printers list message of the printer dialog',
  },
  emptyTitle: {
    id: 'components.printDialog.selectPrinter.empty.title',
    defaultMessage: "We couldn't find any printer",
    description: 'empty printer list title of the printer dialog',
  },
  emptyDescription: {
    id: 'components.printDialog.selectPrinter.empty.description',
    defaultMessage:
      "We couldn't find any printers because there is no Spooler server running with connected printers. Read through our documentation to start a server or use the system dialog to print.",
    description: 'empty printer list description of the printer dialog',
  },
  goToDocs: {
    id: 'components.printDialog.selectPrinter.empty.goToDocs',
    defaultMessage: 'Open documentation',
    description: 'select printer title of the printer dialog',
  },
  printerSavedLocallyMessage: {
    id: 'components.printDialog.printerSavedLocallyMessage',
    defaultMessage:
      'Your selected printer will be saved to print future {category} faster. You can always change it during printing.',
    description: 'Saved printer locally message of the printer dialog',
  },
  printingFeedbackMessage: {
    id: 'feedback.printing.message',
    defaultMessage: 'Print {category}',
    description: 'Feedback message for printing',
  },
  printingFailed: {
    id: 'feedback.printing.failed.title',
    defaultMessage: 'Printing failed',
    description: 'Feedback title for printing failed',
  },
  spoolerDesktopDocsLink: {
    id: 'links.spoolerDesktopDocsLink',
    defaultMessage: 'https://afosto.com/docs/apps/spooler/desktop/',
    description: 'Link to the spooler desktop documentation',
  },
});
